module.exports = __webpack_public_path__ + "img/banner-dexid_optim.2ecec8ab.webp";